import React, { useEffect, useState, useContext } from 'react';
import { Drawer, useDrawerState } from '@yuhuinc/ui-library';
import { Button, message } from 'antd';

import { getTranslatedString } from 'helpers/i18n';
import AssignUnit from 'components/landlord_app/application_management/assign_unit/AssignUnit';
import { getSitesAndProperties } from '../../store/actions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPutRequest } from 'helpers/ApiHelper';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const translate = (key) =>
  getTranslatedString(
    `landlordPortal.applicationManagement.applicationOverview.overview.assignNewUnit.${key}`
  );

const AssignNewUnitButton = () => {
  const [, assignUnitDrawer] = useDrawerState(false);
  const [sitesAndProperties, setSitesAndProperties] = useState([]);
  const [loadingSitesAndProperties, setLoadingSitesAndProperties] = useState(false);
  const queryClient = useQueryClient();
  const currentApplication = useContext(CurrentApplicationContext);

  const assignNewUnitMutation = useMutation({
    mutationFn: (data) =>
      apiPutRequest(
        `/landlords/application_management/applications/${currentApplication.id}/assign_unit`,
        data
      ),
    onSuccess() {
      message.success(translate('success'));
      queryClient.invalidateQueries({ queryKey: ['applications'] });
      assignUnitDrawer.close();
    },
    onError() {
      message.error(translate('error'));
    },
  });

  useEffect(() => {
    setLoadingSitesAndProperties(true);
    getSitesAndProperties({ onlyReviewableProperties: true })
      .done((response) => {
        setSitesAndProperties(response.sites);
      })
      .always(() => setLoadingSitesAndProperties(false));
  }, []);

  return (
    <>
      <Button type="primary" onClick={assignUnitDrawer.open}>
        {translate('button')}
      </Button>

      <Drawer
        title={translate('title')}
        visible={assignUnitDrawer.isVisible}
        closable
        destroyOnClose
        onClose={assignUnitDrawer.close}
      >
        <AssignUnit
          siteAndProperties={sitesAndProperties}
          loadingSiteAndProperties={loadingSitesAndProperties}
          closeDrawer={assignUnitDrawer.close}
          onAdd={(unit) => {
            assignNewUnitMutation.mutate({ property_id: unit.property_id, unit_id: unit.key });
          }}
          assignUnitQuery={{}}
        />
      </Drawer>
    </>
  );
};

export default AssignNewUnitButton;
